import { useState } from 'react';
import { useNavigate } from 'react-router';
import type React from 'react';
import { FormInput } from '@podus/ui';
import AuthLayout from '@/components/AuthLayout';
import { api } from '@/lib/api';

export default function Login() {
    const navigate = useNavigate();
    const [identifier, setIdentifier] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!identifier.trim()) {
            setError('Please enter your email address.');
            return;
        }
        setError('');
        setIsLoading(true);

        try {
            await api.post('/api/auth/staff/login', { email: identifier.trim() });
            navigate('/verify-otp', { state: { identifier: identifier.trim() } });
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : 'Failed to send OTP. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AuthLayout>
            <h2 className="mt-10 text-[20px] font-bold text-secondary sm:text-[22px]">Sign in to your account</h2>

            <form onSubmit={handleSubmit} className="mt-8">
                <FormInput
                    title="Email Address"
                    id="identifier"
                    type="email"
                    placeholder="Enter your email address"
                    value={identifier}
                    variant="white"
                    onChange={(e) => {
                        setIdentifier(e.target.value);
                        if (error) setError('');
                    }}
                />

                {error && <p className="mt-2 text-sm text-red-500">{error}</p>}

                <button
                    type="submit"
                    disabled={isLoading}
                    className="mt-6 flex w-full items-center justify-center rounded-lg bg-secondary py-3.5 text-[15px] font-bold text-white transition-all hover:bg-secondary-400 disabled:opacity-60"
                >
                    {isLoading ? (
                        <svg className="h-5 w-5 animate-spin" viewBox="0 0 24 24" fill="none">
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                            />
                        </svg>
                    ) : (
                        'Sign In'
                    )}
                </button>
            </form>
        </AuthLayout>
    );
}
